import { Button, ChatContainer, Layout } from "@/components";
import { useAuth } from "@/context";
import { useChat } from "@/hooks";
import React from "react";

export const ChatPage: React.FC = () => {
  const { error: authError } = useAuth();

  // Hook real do chat
  const {
    messages,
    session,
    status,
    loading,
    error,
    sendMessage,
    createNewSession,
    clearMessages,
    checkConnection,
  } = useChat();

  const handleSendMessage = async (message: string) => {
    if (!session) {
      // Criar nova sessão se não existir
      await createNewSession();
      // Aguardar um pouco e tentar enviar novamente
      setTimeout(() => {
        if (session) {
          sendMessage(message);
        }
      }, 500);
    } else {
      await sendMessage(message);
    }
  };

  const handleClearChat = () => {
    clearMessages();
  };

  const handleRefreshChat = () => {
    checkConnection();
  };

  const handleNewSession = () => {
    createNewSession();
  };

  return (
    <Layout className="flex flex-col h-screen">
      <div className="flex-1 flex flex-col w-full h-full overflow-hidden">
        {/* Notificação de sessão expirada */}
        {authError === "Sessão expirada" && (
          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4 mx-6 mt-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  Sessão Expirada
                </h3>
                <div className="mt-2 text-sm text-red-700">
                  <p>
                    Sua sessão foi encerrada no Keycloak. Você será
                    redirecionado para o login.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Status e Controles */}
        <div className="flex items-center justify-center space-x-4 px-6 py-4">
          <Button
            variant="primary"
            size="sm"
            onClick={handleNewSession}
            disabled={loading}
          >
            Nova Sessão
          </Button>
        </div>

        {/* Error Display */}
        {error && (
          <div className="mx-6 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-700 text-sm">{error}</p>
          </div>
        )}

        {/* Chat Container - Ocupa todo o espaço restante */}
        <div className="flex-1 flex flex-col mx-6 mb-6 bg-white rounded-lg shadow-lg overflow-hidden min-h-0">
          <ChatContainer
            sessionId={session?.sessionId || "sem-sessao"}
            messages={messages}
            status={status}
            loading={loading}
            onSendMessage={handleSendMessage}
            onRefresh={handleRefreshChat}
            onClear={handleClearChat}
            className="flex-1"
          />
        </div>
      </div>
    </Layout>
  );
};
